export default __webpack_public_path__ + "static/media/icon-lili-bay.e6dbaf70.png";